import React from 'react';
import MediaQuery from 'react-responsive/src/Component';
import MachineCraft from 'components/organisms/machineCraft';
import MachineCraftMobile from 'components/organisms/machineCraftMobile';

const MachineCraftSection = props => {
  return (
    <div id={'machine-craft'}>
      <MediaQuery maxDeviceWidth={575.6}>
        <MachineCraftMobile
          data={props}
          breadcrumbList={props.breadcrumbList}
        />
      </MediaQuery>
      <MediaQuery minDeviceWidth={576}>
        <MachineCraft data={props} breadcrumbList={props.breadcrumbList} />
      </MediaQuery>
    </div>
  );
};

export default MachineCraftSection;
